import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/app-sidebar';

export function QueryEditorPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to databases page where query editor is accessible
    navigate({ to: '/databases' });
  }, [navigate]);

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <div className="flex items-center justify-center h-screen">
          <p className="text-muted-foreground">Redirecting to databases...</p>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
